'use client';

import { getPostHog } from './posthog';

/**
 * Viral CTA Event Tracking
 *
 * Story 6.11: Viral CTA A/B Testing
 *
 * PostHog event tracking for viral CTA impressions, clicks,
 * and badge clicks. Silently fails if PostHog is unavailable.
 */

/**
 * Track when a viral CTA becomes visible to the user.
 * Should be fired once per session when the CTA first appears.
 */
export function trackViralCTAImpression(
  botId?: string,
  variant?: string,
  creatorId?: string
): void {
  const posthog = getPostHog();
  if (!posthog) return;

  posthog.capture('viral_cta_impression', {
    ...(botId && { bot_id: botId }),
    ...(variant && { variant }),
    ...(creatorId && { creator_id: creatorId }),
  });
}

/**
 * Track when a user clicks the viral CTA.
 * Fired before navigation to the creator app.
 */
export function trackViralCTAClick(
  botId?: string,
  variant?: string,
  creatorId?: string
): void {
  const posthog = getPostHog();
  if (!posthog) return;

  posthog.capture('viral_cta_click', {
    ...(botId && { bot_id: botId }),
    ...(variant && { variant }),
    ...(creatorId && { creator_id: creatorId }),
  });
}

/**
 * Track when a user clicks the "Powered by Boty.ai" badge.
 */
export function trackViralBadgeClick(botId?: string): void {
  const posthog = getPostHog();
  if (!posthog) return;

  posthog.capture('viral_badge_click', {
    ...(botId && { bot_id: botId }),
  });
}
